import React from "react";
import PropTypes from "prop-types";

import { formatValue } from "../format";
import CouponField from "./CouponField";
import {
  SummaryBoxWrap,
  SummaryRow,
  BoxDivider,
  TotalRow,
} from "../styles";

export default function SummaryBox({ totals, displayMode, ...couponProps }) {
  return (
    <SummaryBoxWrap>
      <SummaryRow>
        <span>Frete do pedido:</span>
        <span className="value">
          {formatValue(displayMode, totals.shippingMoney, totals.shippingPoints)}
        </span>
      </SummaryRow>
      <SummaryRow>
        <span>Subtotal do pedido:</span>
        <span className="value">
          {formatValue(displayMode, totals.subtotalMoney, totals.subtotalPoints)}
        </span>
      </SummaryRow>

      <BoxDivider />

      <CouponField {...couponProps} />

      <BoxDivider />

      <TotalRow>
        <span className="total-label">Total do pedido</span>
        <span className="total-value">
          {formatValue(displayMode, totals.totalMoney, totals.totalPoints)}
        </span>
      </TotalRow>
    </SummaryBoxWrap>
  );
}

SummaryBox.propTypes = {
  totals: PropTypes.object,
  displayMode: PropTypes.oneOf(["money", "points", "both"]),
};
